module.exports = __webpack_public_path__ + "static/img/lcs.c851a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lcs.jpg
// module id = jcZy
// module chunks = 1